import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-all-done-dialog',
  templateUrl: './all-done-dialog.component.html',
  styleUrls: ['./all-done-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllDoneDialogComponent {}
